import { csCZ, enUS } from '@mui/x-data-grid-pro/locales';
import { useTranslation } from 'react-i18next';
import { useLanguage } from 'utils/hooks/useLanguage';

const useGridLocalization = () => {
  const { currentLocale } = useLanguage();
  const { t } = useTranslation();

  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

  return {
    ...(currentLocale === 'en'
      ? enUS.components.MuiDataGrid.defaultProps.localeText
      : {
          ...csCZ.components.MuiDataGrid.defaultProps.localeText,

          // TO DO: missing localisation strings in mui-x@7.23.1
          // Can be deleted once they appear in oggicial github repo
          filterOperatorDoesNotContain: t('Grid:filterOperatorDoesNotContain'),
          filterOperatorDoesNotEqual: t('Grid:filterOperatorDoesNotEqual'),

          headerFilterOperatorDoesNotContain: capitalize(t('Grid:filterOperatorDoesNotContain')),
          headerFilterOperatorDoesNotEqual: capitalize(t('Grid:filterOperatorDoesNotEqual')),
        }),
    detailPanelToggle: capitalize(t('Studies:listOfSeries')),
  };
};

export default useGridLocalization;
